import React, { useState, useEffect, useRef } from "react";
import { keepSavedPricingIfUntouched, savedPricingNotice } from "./editPricingGuard";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import countryOptions from "../../components/List/Countries";
import { FormControlLabel } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import CrudService from "services/cruds-service";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import "jspdf-autotable";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import { tr } from "date-fns/locale";
import { companies } from "../../companies";
import {EXTRA_CHARGE_TYPES} from "../../../../../../constants/extraCostProjectCargo";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreateCustomer from "../../crm/customer/CreateCustomer";
import CreateServiceProvider from "../../crm/Service Provider/CreateServiceProvider";
import { AddRowButton, RemoveRowButton } from "components/RowActions";

const ProjectCargoForm = ({ selectedTransportType }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const initialAddressState = {
        additionalInfo: "",
        country: "",
        city: "",
        officeCode: "",
        brokerageName: "",
        declarationNumber: "",
    };

    const incotermsOptions = [
        { label: "CFR" },
        { label: "CIF" },
        { label: "CIP" },
        { label: "CPT" },
        { label: "DAP" },
        { label: "DAT" },
        { label: "DPU" },
        { label: "DDP" },
        { label: "EXW" },
        { label: "FAS" },
        { label: "FCA" },
        { label: "FOB" },
        { label: "FOT" },
        { label: "FOR" },
    ];

    const statusOptions = [
        { value: "Pending", label: "Pending", color: "#FFB300" },
        { value: "Sent", label: "Sent", color: "#1E88E5" },
        { value: "Secured", label: "Secured", color: "#43A047" },
        { value: "Lost", label: "Lost", color: "#E53935" },
        { value: "Closed", label: "Closed", color: "#546E7A" },
    ];

    const Dot = ({ color }) => (
        <span
            style={{
                display: "inline-block",
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: color || "#999",
                marginRight: 8,
                verticalAlign: "middle",
                flexShrink: 0,
            }}
        />
    );

    const serviceOptions = [
        { label: "Port to Port" },
        { label: "Port to Door" },
        { label: "Door to Port" },
        { label: "Door to Door" },
    ];

    const [inputValue, setInputValue] = useState("");
    const [open, setOpen] = useState(false);

    const imcoOptions = [
        { label: "(1.1) Substances and objects with a mass explosion hazard" },
        { label: "(1.2) Substances and objects with an explosion hazard but without a mass explosion hazard" },
        { label: "(1.3) Substances and objects with a fire hazard and a minor blast or minor projection hazard, or both, but without a mass explosion hazard" },
        { label: "(1.4) Substances and objects posing no significant hazard" },
        { label: "(1.6) Extremely insensitive substances without a mass explosion hazard" },
        { label: "(2.1) Flammable gases" },
        { label: "(2.2) Non-flammable, non-toxic gases" },
        { label: "(2.3) Toxic gases" },
        { label: "(3) Flammable liquids" },
        { label: "(4.1) Flammable solids, substances prone to spontaneous combustion, and solid desensitized explosives" },
        { label: "(4.2) Substances prone to spontaneous combustion" },
        { label: "(4.3) Substances emitting flammable gases when in contact with water" },
        { label: "(5.1) Oxidizing substances" },
        { label: "(5.2) Organic peroxides" },
        { label: "(6.1) Toxic substances" },
        { label: "(7) Radioactive substances" },
        { label: "(8) Corrosive substances" },
        { label: "(9) Miscellaneous dangerous substances and objects" },
    ];
    const [exchangeRates, setExchangeRates] = useState(null);
    const [loadingRates, setLoadingRates] = useState(false);

    useEffect(() => {
        async function loadRates() {
            setLoadingRates(true);
            try {
                const res = await fetch("https://api.exchangerate-api.com/v4/latest/EUR");
                const data = await res.json();
                setExchangeRates(data.rates);
            } catch (err) {
                console.error("Error fetching exchange rates:", err);
            } finally {
                setLoadingRates(false);
            }
        }
        loadRates();
    }, []);


    const convertToBase = (amount, fromCurrency) => {
        if (!exchangeRates) return 0;
        if (!amount || !fromCurrency) return 0;

        if (fromCurrency === baseCurrency) return Number(amount);

        const rateFrom = exchangeRates[fromCurrency];
        const rateTo = exchangeRates[baseCurrency];

        if (!rateFrom || !rateTo) return 0;

        return (Number(amount) / rateFrom) * rateTo;
    };


    const [customerModalOpen, setCustomerModalOpen] = useState(false);
    const [customerModalTarget, setCustomerModalTarget] = useState(null);

    const NEW_PARTY_OPTION = {
        id: "new-party",
        name: "+ New",
        type: "new",
    };

    const handleCustomerCreatedFromModal = (createdCustomer) => {
        const attr = createdCustomer?.attributes || createdCustomer;

        const newOption = {
            id: createdCustomer?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Customer",
            type: "customer",
        };

        setCustomerOptions((prev) => {
            const exists = prev.some(
                (item) => item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        setPartyOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    item.type === "customer" &&
                    item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (customerModalTarget === "customer") {
            setSelectedCustomer(newOption);
            setInputValue(newOption.name);
        }

        if (customerModalTarget === "shipper") {
            setShipper(newOption.name);
        }

        if (customerModalTarget === "consignee") {
            setConsignee(newOption.name);
        }

        setCustomerModalOpen(false);
        setCustomerModalTarget(null);
    };

    const handleServiceProviderCreatedFromModal = (createdProvider) => {
        const attr = createdProvider?.attributes || createdProvider;

        const newOption = {
            id: createdProvider?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Service Provider",
            type: "serviceProvider",
        };

        setCarrierOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (serviceProviderModalTargetIndex !== null) {
            handleCarrierChange(
                serviceProviderModalTargetIndex,
                "name",
                newOption.name
            );
        }

        setServiceProviderModalOpen(false);
        setServiceProviderModalTargetIndex(null);
    };

    const [customerOptions, setCustomerOptions] = useState([]);
    const [partyOptions, setPartyOptions] = useState([]);

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [customersRes, agentsRes] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customersRes.data || []).map((c) => ({
                    id: c.id,
                    name: c.attributes?.name || "Unnamed Customer",
                    type: "customer",
                }));

                const agents = (agentsRes.data || []).map((a) => ({
                    id: a.id,
                    name: a.attributes?.name || a.name || "Unnamed Global Agent",
                    type: "agent",
                }));

                const merged = [...customers, ...agents].sort((x, y) =>
                    (x.name || "").localeCompare(y.name || "")
                );

                setCustomerOptions(customers);  // ✅ EKLE
                setPartyOptions(merged);
            } catch (err) {
                console.error("Options alınırken hata oluştu:", err);
            } finally {
                setCustomersLoaded(true);
            }
        };

        fetchOptions();
    }, []);

    // companies (string[]) + partyOptions (object[]) => string[]
    const shipperConsigneeOptions = React.useMemo(() => {
        const companyItems = (companies || [])
            .map((name) => String(name || "").trim())
            .filter(Boolean)
            .map((name) => ({
                id: `company-${name.toLowerCase()}`,
                name,
                type: "company",
            }));

        const partyItems = (partyOptions || [])
            .filter((p) => p?.name)
            .map((p) => ({
                id: `${p.type}-${p.id}`,
                name: String(p.name).trim(),
                type: p.type, // "customer" | "agent"
            }));

        // unique by (type + name) (aynı isim farklı tipte olabilir)
        const map = new Map();
        [...companyItems, ...partyItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [partyOptions, companies]);

    const findOptionByName = (name) =>
        shipperConsigneeOptions.find(
            (o) => (o.name || "").toLowerCase() === String(name || "").toLowerCase()
        ) || null;

    const [salesRepOptions, setSalesRepOptions] = useState([]);
    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map((user) => ({
                    id: user.id,
                    label: user.attributes.name,
                }));

                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            } finally {
                setSalesRepsLoaded(true);
            }
        };
        fetchSalesReps();
    }, []);

    const getExtraChargeOptionsByMode = (modeType = []) => {
        if (!Array.isArray(modeType) || modeType.length === 0) return [];

        const result = [];

        modeType.forEach((mode) => {
            const groups = EXTRA_CHARGE_TYPES[mode];
            if (!groups) return;

            Object.entries(groups).forEach(([groupLabel, items]) => {
                items.forEach((item) => {
                    result.push({
                        group: groupLabel,
                        label: item,
                        mode,
                    });
                });
            });
        });

        return result;
    };



    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const quotingToolId = searchParams.get("id");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const submittingRef = useRef(false); // çift tıklamada mükerrer kayıt oluşmasın
    const [customersLoaded, setCustomersLoaded] = useState(false);
    const [salesRepsLoaded, setSalesRepsLoaded] = useState(false);
    const [editDataLoaded, setEditDataLoaded] = useState(false);
    const editFetchStartedRef = useRef(false);
    const savedRecordRef = useRef(null); // düzenlenen kaydın DB'deki hali (fiyat koruması için)
    // Kayıttan sonraki yönlendirme: kullanıcı bu sürede sayfadan çıkarsa onu geri tabloya atmasın
    const redirectTimerRef = useRef(null);
    useEffect(() => () => clearTimeout(redirectTimerRef.current), []);
    const successMessageRef = useRef(null);

    const [carrierOptions, setCarrierOptions] = useState([]);
    const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);
    const [serviceProviderModalTargetIndex, setServiceProviderModalTargetIndex] = useState(null);

    const NEW_SERVICE_PROVIDER_OPTION = {
        id: "new-service-provider",
        name: "+ New Account",
        type: "new",
    };

    // Düzenlenecek kaydı müşteri/temsilci listeleri yüklendikten sonra yalnızca bir kez çek.
    // Liste sonradan değişirse (ör. modal ile yeni müşteri eklenince) kullanıcının
    // kaydedilmemiş değişiklikleri DB verisiyle ezilmesin.
    useEffect(() => {
        if (!quotingToolId) return;
        setIsEditing(true);
        if (!customersLoaded || !salesRepsLoaded) return;
        if (editFetchStartedRef.current) return;
        editFetchStartedRef.current = true;
        fetchQuotingToolDetails(quotingToolId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotingToolId, customersLoaded, salesRepsLoaded]);

    // STATES
    const [exportLocation, setExportLocation] = useState(initialAddressState);
    const [importLocation, setImportLocation] = useState(initialAddressState);

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [salesRep, setSalesRep] = useState([]);
    const [carriers, setCarriers] = useState([{ id: 1, name: "", cost: "", currency: "" }]);
    const [consignee, setConsignee] = useState("");
    const [commodity, setCommodity] = useState("");
    const [grossWeight, setGrossWeight] = useState("");
    const [chargeableWeight, setChargeableWeight] = useState("");
    const [quoteNo, setQuoteNo] = useState("");
    const [transitTime, setTransitTime] = useState("");
    const [originFreeTime, setOriginFreeTime] = useState("");
    const [destinationFreeTime, setDestinationFreeTime] = useState("");
    const [selectedIncoterm, setSelectedIncoterm] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [shipper, setShipper] = useState("");
    const [estimatedCloseDate, setEstimatedCloseDate] = useState(null);
    const [quoteDate, setQuoteDate] = useState(null);
    const [quoteType, setQuoteType] = useState(null);
    const [freightCost, setFreightCost] = useState("");
    const [freightCostCurrency, setFreightCostCurrency] = useState("");
    const [originSallingRate, setOriginSallingRate] = useState("");
    const [originSallingRateCurrency, setOriginSallingRateCurrency] = useState("");
    const [destinationSallingRate, setDestinationSallingRate] = useState("");
    const [destinationSallingRateCurrency, setDestinationSallingRateCurrency] = useState("");
    const [sallingRate, setSallingRate] = useState("");
    const [currency, setCurrency] = useState("");
    const [description, setDescription] = useState("");
    const [modeType, setModeType] = useState([]);
    const [isADR, setIsADR] = useState(false);
    const [imco, setImco] = useState(null);

    const [isOriginCustomsClearance, setIsOriginCustomsClearance] = useState(false);
    const [originCost, setOriginCost] = useState("");
    const [originCurrency, setOriginCurrency] = useState("");
    const [isDestinationCustomsClearance, setIsDestinationCustomsClearance] = useState(false);
    const [destinationCost, setDestinationCost] = useState("");
    const [destinationCurrency, setDestinationCurrency] = useState("");
    const [pickupCountry, setPickupCountry] = useState(null);
    const [pickupCity, setPickupCity] = useState(null);
    const [pickupCityOptions, setPickupCityOptions] = useState([]);
    const [deliveryCountry, setDeliveryCountry] = useState(null);
    const [deliveryCity, setDeliveryCity] = useState(null);
    const [deliveryCityOptions, setDeliveryCityOptions] = useState([]);
    // ✅ NEW: Exit customs country (separate from arrival)
    const [exitCustomsCountry, setExitCustomsCountry] = useState(null);

    const [arrivalCustomsCountry, setArrivalCustomsCountry] = useState(null);
    const [arrivalCustomsCity, setArrivalCustomsCity] = useState(null);
    const [arrivalCustomsCityOptions, setArrivalCustomsCityOptions] = useState([]);
    const [airPricingMode, setAirPricingMode] = useState("ALL_IN");
    const baseCurrency = currency || "EUR";
    const [createdSource, setCreatedSource] = useState("manual");
    const [prefillRefId, setPrefillRefId] = useState(null);

    const [extraCosts, setExtraCosts] = useState([
        {
            type: "",
            amount: "",
            currency: "EUR",
            extraSelling: "",
            extraSellingRate: "EUR",
        },
    ]);

    const [sellingDriver, setSellingDriver] = useState("PERCENT"); // "PERCENT" | "UNIT" | "SELLING"
    const [activeSellingField, setActiveSellingField] = useState(null);

    const [marginPercentInput, setMarginPercentInput] = useState("");
    const [marginUnitInput, setMarginUnitInput] = useState("");
    const [sellingRateInput, setSellingRateInput] = useState("");

    const [hydratingFromDb, setHydratingFromDb] = useState(false);

    // ===== RFQ TRANSFER (Project Cargo) =====
    const rfqAppliedRef = useRef(false);

// component içinde üstlere koy

    useEffect(() => {
        const rfqPayload =
            location?.state?.rfq ||
            location?.state?.rfqData ||
            location?.state?.data ||
            location?.state?.payload ||
            null;

        const prefill =
            location?.state?.prefill ||
            location?.state?.prefillData ||
            location?.state?.rfqPrefill ||
            null;

        // ✅ tek payload: rfq varsa rfq, yoksa prefill
        const payload = rfqPayload || prefill;

        // ✅ sadece CREATE modunda
        if (quotingToolId) return;
        if (isEditing) return;
        if (!payload) return;

        // ✅ options hazır değilse bekle (customer + salesRep)
        const needsCustomer = !!(payload.customerId || payload.customerName || payload.customer);
        const repIds = payload.salesRepIds || payload.salesRep || [];
        const needsReps = Array.isArray(repIds) && repIds.length > 0;

        if (needsCustomer && customerOptions.length === 0) return;
        if (needsReps && salesRepOptions.length === 0) return;

        // ✅ 1 kere uygula
        if (rfqAppliedRef.current) return;

        const norm = (v) => String(v || "").trim().toLowerCase();

        const findCountry = (label) =>
            countryOptions.find((c) => norm(c.label) === norm(label)) || null;

        const safeDate = (v) => {
            if (!v) return null;
            const d = new Date(v);
            return isNaN(d.getTime()) ? null : d;
        };

        const matchCompany = (val) => {
            const key = norm(val);
            if (!key) return "";
            // companies string[] gibi duruyor sende
            const found = (companies || []).find((c) => norm(c?.label ?? c) === key);
            return found || (val || "");
        };

        // =========================
        // ✅ PREFILL META
        // =========================
        if (prefill) {
            setCreatedSource("prefill");
            setPrefillRefId(
                prefill?.id ||
                prefill?.rfqId ||
                prefill?.rfqNumber ||
                prefill?.prefillRefId ||
                null
            );
        } else {
            setCreatedSource("manual");
        }

        // =========================
        // ✅ CUSTOMER
        // =========================
        const customerName =
            payload.customerName ||
            payload.customer?.name ||
            payload.customer ||
            "";

        const matchedCustomer =
            (payload.customerId
                ? customerOptions.find((x) => String(x.id) === String(payload.customerId))
                : null) ||
            customerOptions.find((x) => norm(x.name) === norm(customerName)) ||
            null;

        if (matchedCustomer) {
            setSelectedCustomer(matchedCustomer);
            setInputValue(matchedCustomer.name);
            setOpen(false);
        }

        // =========================
        // ✅ SALES REP
        // =========================
        if (needsReps) {
            const idSet = new Set(repIds.map((x) => String(x)));
            setSalesRep(salesRepOptions.filter((x) => idSet.has(String(x.id))));
        }

        // =========================
        // ✅ BASIC FIELDS
        // =========================
        if (payload.quoteType) setQuoteType(payload.quoteType);

        if (payload.shipper) setShipper(matchCompany(payload.shipper));
        if (payload.consignee) setConsignee(matchCompany(payload.consignee));

        if (payload.commodity) setCommodity(payload.commodity);
        if (payload.grossWeight != null) setGrossWeight(String(payload.grossWeight));
        if (payload.chargeableWeight != null) setChargeableWeight(String(payload.chargeableWeight));

        if (payload.transitTime != null) setTransitTime(String(payload.transitTime));
        if (payload.originFreeTime != null) setOriginFreeTime(String(payload.originFreeTime));
        if (payload.destinationFreeTime != null) setDestinationFreeTime(String(payload.destinationFreeTime));

        if (payload.serviceMode) setSelectedService(String(payload.serviceMode).trim());
        if (payload.incoterm) setSelectedIncoterm(payload.incoterm);
        if (payload.status) setSelectedStatus(payload.status);

        if (payload.quoteDate) setQuoteDate(safeDate(payload.quoteDate));
        if (payload.estimatedCloseDate) setEstimatedCloseDate(safeDate(payload.estimatedCloseDate));

        if (payload.currency) setCurrency(payload.currency);
        if (payload.airPricingMode) setAirPricingMode(payload.airPricingMode);

        if (payload.modeType) setModeType(Array.isArray(payload.modeType) ? payload.modeType : [payload.modeType]);

        // =========================
        // ✅ LOCATIONS (RFQ + PREFILL fallback)
        // =========================
        // pickup
        const pickupCountryLabel =
            payload.pickupLocation?.country ||
            payload.pickupCountry ||
            payload.originCountry ||
            payload.origin ||
            "";

        const pickupCityLabel =
            payload.pickupLocation?.city ||
            payload.pickupCity ||
            payload.originCity ||
            "";

        if (pickupCountryLabel) {
            const c = findCountry(pickupCountryLabel) || { label: pickupCountryLabel };
            setPickupCountry(c);
            if (pickupCityLabel) setPickupCity({ label: pickupCityLabel }); // options gelince eşleşir
        }

        // delivery
        const deliveryCountryLabel =
            payload.deliveryLocation?.country ||
            payload.deliveryCountry ||
            payload.destinationCountry ||
            payload.destination ||
            "";

        const deliveryCityLabel =
            payload.deliveryLocation?.city ||
            payload.deliveryCity ||
            payload.destinationCity ||
            "";

        if (deliveryCountryLabel) {
            const c = findCountry(deliveryCountryLabel) || { label: deliveryCountryLabel };
            setDeliveryCountry(c);
            if (deliveryCityLabel) setDeliveryCity({ label: deliveryCityLabel });
        }

        // export (exit customs)
        const exitCountryLabel =
            payload.exportLocation?.country ||
            payload.exitCustomsCountry ||
            payload.polCountry ||
            "";

        const exitInfo =
            payload.exportLocation?.additionalInfo ||
            payload.exitCustomsInfo ||
            payload.exportAdditionalInfo ||
            "";

        if (exitCountryLabel) {
            const c = findCountry(exitCountryLabel) || { label: exitCountryLabel };
            setExitCustomsCountry(c);
            setExportLocation((prev) => ({
                ...prev,
                country: exitCountryLabel,
                additionalInfo: exitInfo,
            }));
        } else if (exitInfo) {
            setExportLocation((prev) => ({ ...prev, additionalInfo: exitInfo }));
        }

        // import (arrival customs)
        const arrivalCountryLabel =
            payload.importLocation?.country ||
            payload.arrivalCustomsCountry ||
            payload.podCountry ||
            "";

        const arrivalInfo =
            payload.importLocation?.additionalInfo ||
            payload.arrivalCustomsInfo ||
            payload.importAdditionalInfo ||
            "";

        const arrivalCityLabel =
            payload.importLocation?.city ||
            payload.arrivalCustomsCity ||
            "";

        if (arrivalCountryLabel) {
            const c = findCountry(arrivalCountryLabel) || { label: arrivalCountryLabel };
            setArrivalCustomsCountry(c);
            setImportLocation((prev) => ({
                ...prev,
                country: arrivalCountryLabel,
                additionalInfo: arrivalInfo,
            }));
            if (arrivalCityLabel) setArrivalCustomsCity({ label: arrivalCityLabel });
        } else if (arrivalInfo) {
            setImportLocation((prev) => ({ ...prev, additionalInfo: arrivalInfo }));
        }

        // =========================
        // ✅ ARRAYS (varsa)
        // =========================
        if (Array.isArray(payload.carriers) && payload.carriers.length) {
            setCarriers(payload.carriers);
        }

        if (Array.isArray(payload.extraCosts) && payload.extraCosts.length) {
            setExtraCosts(payload.extraCosts);
        }

        if (payload.description) setDescription(payload.description);

        // ✅ EN SON kilitle
        rfqAppliedRef.current = true;
    }, [location.state, quotingToolId, isEditing, customerOptions, salesRepOptions]);
    const prefill =
        location.state?.prefill ||
        location.state?.prefillData ||
        location.state?.rfqPrefill ||
        null;

    useEffect(() => {
        if (!prefill) return;
        if (quotingToolId) return; // edit modunda ezme

        setCreatedSource("prefill");

        // RFQ id / ref nerede ise onu yaz
        setPrefillRefId(
            prefill?.id ||
            prefill?.rfqId ||
            prefill?.rfqNumber ||
            prefill?.prefillRefId ||
            null
        );

    }, [prefill, quotingToolId]);

    const extraChargeOptions = React.useMemo(() => {
        return getExtraChargeOptionsByMode(modeType);
    }, [modeType]);

    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const citiesCacheRef = useRef(new Map());
    const normalizeKey = (v) => String(v || "").trim().toLowerCase();

    const loadCitiesByCountry = async (countryLabel) => {
        const key = normalizeKey(countryLabel);
        if (!key) return [];

        if (citiesCacheRef.current.has(key)) {
            return citiesCacheRef.current.get(key);
        }

        const res = await CrudService.getCitiesByCountryOpp(countryLabel);

        const raw =
            Array.isArray(res?.data) ? res.data :
                Array.isArray(res?.data?.data) ? res.data.data :
                    Array.isArray(res?.data?.items) ? res.data.items :
                        Array.isArray(res?.data?.attributes) ? res.data.attributes :
                            [];

        const list = raw
            .map((c) => ({
                label: (typeof c === "string" ? c : (c?.label || c?.name || c?.city || c?.attributes?.name || ""))?.trim(),
            }))
            .filter((x) => x.label);

        citiesCacheRef.current.set(key, list);
        return list;
    };

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!pickupCountry?.label) {
                setPickupCityOptions([]);
                setPickupCity(null);
                return;
            }
            const list = await loadCitiesByCountry(pickupCountry.label);
            if (!cancelled) setPickupCityOptions(list);
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [pickupCountry]);

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!deliveryCountry?.label) {
                setDeliveryCityOptions([]);
                setDeliveryCity(null);
                return;
            }
            const list = await loadCitiesByCountry(deliveryCountry.label);
            if (!cancelled) setDeliveryCityOptions(list);
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [deliveryCountry]);

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!arrivalCustomsCountry?.label) {
                setArrivalCustomsCityOptions([]);
                setArrivalCustomsCity(null);
                return;
            }
            const list = await loadCitiesByCountry(arrivalCustomsCountry.label);
            if (!cancelled) setArrivalCustomsCityOptions(list);
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [arrivalCustomsCountry]);

    const renderCountryAutocomplete = (label, options, value, setValue, extraProps = {}) => (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            renderOption={({ key: optionKey, ...props }, option) => (
                <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                    {option.flagUrl && (
                        <img
                            src={option.flagUrl}
                            alt={`${option.label} flag`}
                            width="20"
                            height="15"
                            style={{ marginRight: 8 }}
                        />
                    )}
                    {option.label}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={label}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        "& .MuiInputBase-root": { height: 45 },
                        ...(extraProps.inputSx || {}),
                    }}
                />
            )}
        />
    );

    const fetchQuotingToolDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getQuotingToolById(id);
            const quotingToolData = response.data.attributes;

            const findCountryOption = (countryLabel) => {
                const key = normalizeKey(countryLabel);
                return countryOptions.find((c) => normalizeKey(c.label) === key) || null;
            };

            const findCityOption = (cityLabel, list) => {
                const key = normalizeKey(cityLabel);
                return (list || []).find((c) => normalizeKey(c.label) === key) || null;
            };

            const matchedCustomer = customerOptions.find(
                (opt) => opt.name?.trim().toLowerCase() === quotingToolData.customer?.trim().toLowerCase()
            );
            setSelectedCustomer(matchedCustomer || (quotingToolData.customer ? { id: null, name: quotingToolData.customer, type: "customer" } : null)); // listede yoksa kayıttaki adı koru

            setSalesRep(
                Array.isArray(quotingToolData.salesRep)
                    ? salesRepOptions.filter((repOption) => quotingToolData.salesRep.includes(repOption.id))
                    : []
            );

            setQuoteType(quotingToolData.quoteType ?? "");
            setModeType(quotingToolData.modeType || []);
            setShipper(quotingToolData.shipper ?? "");
            setConsignee(quotingToolData.consignee ?? "");
            setCommodity(quotingToolData.commodity ?? "");
            setGrossWeight(quotingToolData.grossWeight ?? "");
            setChargeableWeight(quotingToolData.chargeableWeight ?? "");
            setQuoteNo(quotingToolData.quoteNo ?? "");
            setTransitTime(quotingToolData.transitTime ?? "");
            setOriginFreeTime(quotingToolData.originFreeTime ?? "");
            setDestinationFreeTime(quotingToolData.destinationFreeTime ?? "");
            setSelectedIncoterm(quotingToolData.incoterm ?? "");
            setSelectedStatus(quotingToolData.status ?? "");
            setSelectedService((quotingToolData.service ?? "").trim());

            const fetchedCarriers = quotingToolData.carriers?.length
                ? quotingToolData.carriers.map((carrier) => ({
                    name: carrier.name || "",
                    cost: carrier.cost || "",
                    currency: carrier.currency || "EUR",
                    sellingCarriers: carrier.sellingCarriers || "",
                    sellingCarriersRate: carrier.sellingCarriersRate || "EUR",
                }))
                : [{ name: "", cost: "", currency: "EUR",sellingCarriers:  "",sellingCarriersRate: "EUR"}];
            setCarriers(fetchedCarriers);

            const pickupCountryOpt = findCountryOption(quotingToolData.pickupLocation?.country);
            setPickupCountry(pickupCountryOpt);
            if (pickupCountryOpt?.label) {
                const list = await loadCitiesByCountry(pickupCountryOpt.label);
                setPickupCityOptions(list);
                setPickupCity(findCityOption(quotingToolData.pickupLocation?.city, list));
            } else {
                setPickupCityOptions([]);
                setPickupCity(null);
            }

            const deliveryCountryOpt = findCountryOption(quotingToolData.deliveryLocation?.country);
            setDeliveryCountry(deliveryCountryOpt);
            if (deliveryCountryOpt?.label) {
                const list = await loadCitiesByCountry(deliveryCountryOpt.label);
                setDeliveryCityOptions(list);
                setDeliveryCity(findCityOption(quotingToolData.deliveryLocation?.city, list));
            } else {
                setDeliveryCityOptions([]);
                setDeliveryCity(null);
            }

            // ✅ Exit customs: country + additionalInfo -> exportLocation
            const exitCustomsCountryOpt = findCountryOption(quotingToolData.exportLocation?.country);
            setExitCustomsCountry(exitCustomsCountryOpt);

            setExportLocation({
                ...initialAddressState,
                country: quotingToolData.exportLocation?.country ?? "",
                additionalInfo: quotingToolData.exportLocation?.additionalInfo ?? "",
            });

            // ✅ Arrival customs: country + additionalInfo (and city if you still need it)
            const arrivalCountryOpt = findCountryOption(quotingToolData.importLocation?.country);
            setArrivalCustomsCountry(arrivalCountryOpt);

            if (arrivalCountryOpt?.label) {
                const list = await loadCitiesByCountry(arrivalCountryOpt.label);
                setArrivalCustomsCityOptions(list);
                setArrivalCustomsCity(findCityOption(quotingToolData.importLocation?.city, list));
            } else {
                setArrivalCustomsCityOptions([]);
                setArrivalCustomsCity(null);
            }

            setImportLocation({
                ...initialAddressState,
                country: quotingToolData.importLocation?.country ?? "",
                additionalInfo: quotingToolData.importLocation?.additionalInfo ?? "",
            });

            setEstimatedCloseDate(quotingToolData.estimatedCloseDate ? new Date(quotingToolData.estimatedCloseDate) : null);
            setQuoteDate(quotingToolData.quoteDate ? new Date(quotingToolData.quoteDate) : null);

            setHydratingFromDb(true);

            const mode = quotingToolData.airPricingMode || "ALL_IN";
            setAirPricingMode(mode);

            const savedSelling = Number(quotingToolData.sallingRate || 0);

            if (mode === "ALL_IN") {
                setSellingDriver("SELLING");
                setSellingRateInput(savedSelling ? String(savedSelling) : "");
                setMarginPercentInput("");
                setMarginUnitInput("");
            } else {
                // BREAKDOWN'da satır toplamı esas, inputları da okunur göster
                setSellingDriver("SELLING");
                setSellingRateInput(savedSelling ? String(savedSelling) : "0");
            }

            setTimeout(() => setHydratingFromDb(false), 0);
            setFreightCost(quotingToolData.freightCost ?? "");
            setFreightCostCurrency(quotingToolData.freightCostCurrency ?? "");
            setDestinationSallingRate(quotingToolData.destinationSallingRate ?? "");
            setDestinationSallingRateCurrency(quotingToolData.destinationSallingRateCurrency ?? "");
            setOriginSallingRate(quotingToolData.originSallingRate ?? "");
            setOriginSallingRateCurrency(quotingToolData.originSallingRateCurrency ?? "");
            setSallingRate(quotingToolData.sallingRate ?? "");
            setCurrency(quotingToolData.currency ?? "");
            setDescription(quotingToolData.description ?? "");

            setIsADR(quotingToolData.adr || false);
            setImco(quotingToolData.imco || null);

            setIsOriginCustomsClearance(quotingToolData.originCustomsClearance || false);
            setOriginCost(quotingToolData.originCost ?? "");
            setOriginCurrency(quotingToolData.originCurrency || "USD");

            setIsDestinationCustomsClearance(quotingToolData.destinationCustomsClearance || false);
            setDestinationCost(quotingToolData.destinationCost ?? "");
            setDestinationCurrency(quotingToolData.destinationCurrency || "USD");
            setAirPricingMode(quotingToolData.airPricingMode || "ALL_IN");

            setExtraCosts(
                quotingToolData.extraCosts?.length
                    ? quotingToolData.extraCosts
                    : [{
                        type: "",
                        amount: "",
                        currency: "USD",
                        extraSelling: "",
                        extraSellingRate: "USD",
                    }]
            );
            setCreatedSource(quotingToolData.createdSource || quotingToolData.source || quotingToolData.creationType || "manual");
            setPrefillRefId(quotingToolData.prefillRefId || null);

            // yalnızca tüm alanlar hatasız yüklendiyse kaydetmeye izin ver (yarım form DB yi ezmesin)
            savedRecordRef.current = quotingToolData;
            setEditDataLoaded(true);
        } catch (error) {
            console.error("Error fetching QuotingTool details:", error);
        } finally {
            setLoading(false);
        }
    };


    const submitHandler = async (e) => {
        e.preventDefault();
        if (submittingRef.current) return;
        if (quotingToolId && !editDataLoaded) {
            setErrorMessage("Quote details could not be loaded. Please reload the page before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!selectedCustomer) {
            setErrorMessage("Please select a customer before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (!quoteType) {
            setErrorMessage("Please select a quote type (Import / Export / Domestic / Transit) before saving.");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        setErrorMessage("");
        submittingRef.current = true;
        const totalFreightCost = carriers.reduce((total, carrier) => total + (parseFloat(carrier.cost) || 0), 0);

        const quotingToolData = {
            quoteType,
            modeType,
            customer: selectedCustomer?.name || "Unknown Customer",
            salesRep: salesRep.map((rep) => rep.id),
            shipper,
            consignee,
            commodity,
            // Para birimi seçilmemiş satırlar ekranda baseCurrency ile hesaplanıyor; kayda da öyle gitsin
            carriers: carriers.map((c) => ({ ...c, currency: c.currency || baseCurrency })),
            grossWeight,
            chargeableWeight,
            quoteNo,
            pickupLocation: {
                country: pickupCountry?.label || "",
                city: pickupCity?.label || "",
            },
            deliveryLocation: {
                country: deliveryCountry?.label || "",
                city: deliveryCity?.label || "",
            },

            // ✅ Exit customs -> exportLocation
            exportLocation: {
                ...exportLocation,
                country: exitCustomsCountry?.label || exportLocation.country || "",
            },

            // ✅ Arrival customs -> importLocation
            importLocation: {
                ...importLocation,
                country: arrivalCustomsCountry?.label || importLocation.country || "",
            },

            estimatedCloseDate,
            quoteDate,
            incoterm: selectedIncoterm,
            status: selectedStatus,
            service: selectedService,
            transitTime,
            originFreeTime,
            destinationFreeTime,
            adr: isADR,
            imco: imco || "",
            originCustomsClearance: isOriginCustomsClearance,
            originCost: isOriginCustomsClearance ? originCost : null,
            originCurrency: isOriginCustomsClearance ? originCurrency : null,
            destinationCustomsClearance: isDestinationCustomsClearance,
            destinationCost: isDestinationCustomsClearance ? destinationCost : null,
            destinationCurrency: isDestinationCustomsClearance ? destinationCurrency : null,
            totalFreightCost,
            freightCostCurrency: carriers.length > 0 ? carriers[0].currency || baseCurrency : baseCurrency,
            destinationSallingRate,
            destinationSallingRateCurrency,
            originSallingRate,
            originSallingRateCurrency,
            sallingRate: Number(sellingCalc.finalSelling) || 0,
            // Diğer modlarla aynı: satır bazlı satış toplamları (baseCurrency cinsinden)
            totalCarrierSelling: Number(breakdownSellingTotal - totalExtraSelling) || 0,
            totalExtraSelling: Number(totalExtraSelling) || 0,
            marginPercent: marginPercentInput,
            marginPerUnit: marginUnitInput,
            currency: baseCurrency,
            description,
            selectedTransportType,
            airPricingMode,
            extraCosts,
            createdSource,
            prefillRefId
        };
        // Fiyat girdileri değişmediyse kayıtlı fiyat/marj/toplamlar korunur (kur veya kural farkı fiyatı değiştirmesin)
        if (isEditing) keepSavedPricingIfUntouched(quotingToolData, savedRecordRef.current, useLineSelling);

        try {
            setLoading(true);
            if (isEditing) {
                await CrudService.updateQuotingTool(quotingToolData, quotingToolId);
                setSuccessMessage("Update operation was successfully completed.");
            } else {
                const response = await CrudService.createQuotingTool({ data: quotingToolData });
                const newQuoteNo = response.data?.data?.attributes?.quoteNo;
                if (newQuoteNo) setQuoteNo(newQuoteNo);
                setSuccessMessage("Create operation was successfully completed.");
            }

            window.scrollTo({ top: 0, behavior: "smooth" });
            redirectTimerRef.current = setTimeout(() => {
                navigate("/quoting-tool/quoting-tool-tables/details");
            }, 3000);
        } catch (err) {
            console.error("Request failed: ", err);
            submittingRef.current = false;
            setErrorMessage(err?.errors?.[0]?.detail || err?.message || "Save failed. Please try again.");
            window.scrollTo({ top: 0, behavior: "smooth" });
        } finally {
            setLoading(false);
        }
    };

// =============================
// ✅ SELLING ENGINE (AirForm ile birebir)
// =============================
    const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };

// ALL_IN'e geçince satır sellingleri temizle (Air mantığı)
    const clearLineSelling = React.useCallback(() => {
        setCarriers((prev) =>
            (prev || []).map((c) => ({
                ...c,
                sellingCarriers: "",
                sellingCarriersRate: c.sellingCarriersRate || baseCurrency,
            }))
        );

        setExtraCosts((prev) =>
            (prev || []).map((e) => ({
                ...e,
                extraSelling: "",
                extraSellingRate: e.extraSellingRate || baseCurrency,
            }))
        );
    }, [baseCurrency]);

// ✅ BUYING total (carrier cost + extra cost) => baseCurrency
    const totalBuying = React.useMemo(() => {
        if (!exchangeRates) return 0;

        const carrierBuying = (carriers || []).reduce(
            (s, c) => s + convertToBase(c.cost, c.currency || baseCurrency),
            0
        );

        const extraBuying = (extraCosts || []).reduce(
            (s, e) => s + convertToBase(e.amount, e.currency || baseCurrency),
            0
        );

        return carrierBuying + extraBuying;
    }, [exchangeRates, carriers, extraCosts, baseCurrency]);

    const totalExtraBuying = React.useMemo(() => {
        if (!exchangeRates) return 0;
        return (extraCosts || []).reduce(
            (s, e) => s + convertToBase(e.amount, e.currency || baseCurrency),
            0
        );
    }, [exchangeRates, extraCosts, baseCurrency]);

// ✅ Line selling total (carrier selling + extra selling) => baseCurrency
    const breakdownSellingTotal = React.useMemo(() => {
        if (!exchangeRates) return 0;

        const carrierSelling = (carriers || []).reduce(
            (s, c) =>
                s +
                convertToBase(
                    c.sellingCarriers,
                    c.sellingCarriersRate || c.currency || baseCurrency
                ),
            0
        );

        const extraSelling = (extraCosts || []).reduce(
            (s, e) =>
                s + convertToBase(e.extraSelling, e.extraSellingRate || baseCurrency),
            0
        );

        return carrierSelling + extraSelling;
    }, [exchangeRates, carriers, extraCosts, baseCurrency]);

    const totalExtraSelling = React.useMemo(() => {
        if (!exchangeRates) return 0;
        return (extraCosts || []).reduce(
            (s, e) => s + convertToBase(e.extraSelling, e.extraSellingRate || baseCurrency),
            0
        );
    }, [exchangeRates, extraCosts, baseCurrency]);

// ✅ satır selling girilmiş mi?
    const hasAnySellingInput = React.useMemo(() => {
        const hasCarrier = (carriers || []).some((c) => toNum(c?.sellingCarriers) > 0);
        const hasExtra = (extraCosts || []).some((e) => toNum(e?.extraSelling) > 0);
        return hasCarrier || hasExtra;
    }, [carriers, extraCosts]);

// ✅ Air mantığı: BREAKDOWN veya satır selling varsa => line selling esas
    const useLineSelling = airPricingMode === "BREAKDOWN" || hasAnySellingInput;

    const sellingCalc = React.useMemo(() => {
        const buying = toNum(totalBuying);

        // BREAKDOWN/line selling
        if (useLineSelling) {
            const finalSelling = toNum(breakdownSellingTotal);
            const marginUnit = finalSelling - buying;
            const marginPercent = buying > 0 ? (marginUnit / buying) * 100 : 0;

            return {
                finalSelling,
                finalMarginUnit: Number.isFinite(marginUnit) ? marginUnit : 0,
                finalMarginPercent: Number.isFinite(marginPercent) ? marginPercent : 0,
            };
        }

        // ALL_IN engine: buying + margin
        const pct = Number(marginPercentInput);
        const unit = Number(marginUnitInput);
        const manual = Number(sellingRateInput);

        let finalSelling = buying;
        let finalMarginUnit = 0;
        let finalMarginPercent = 0;

        if (sellingDriver === "PERCENT" && marginPercentInput !== "" && !Number.isNaN(pct)) {
            finalMarginPercent = pct;
            finalMarginUnit = (buying * pct) / 100;
            finalSelling = buying + finalMarginUnit;
        } else if (sellingDriver === "UNIT" && marginUnitInput !== "" && !Number.isNaN(unit)) {
            finalMarginUnit = unit;
            finalMarginPercent = buying > 0 ? (unit / buying) * 100 : 0;
            finalSelling = buying + unit;
        } else if (sellingDriver === "SELLING" && sellingRateInput !== "" && !Number.isNaN(manual)) {
            finalSelling = manual;
            finalMarginUnit = manual - buying;
            finalMarginPercent = buying > 0 ? (finalMarginUnit / buying) * 100 : 0;
        }

        return {
            finalSelling,
            finalMarginUnit: Number.isFinite(finalMarginUnit) ? finalMarginUnit : 0,
            finalMarginPercent: Number.isFinite(finalMarginPercent) ? finalMarginPercent : 0,
        };
    }, [
        useLineSelling,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
        totalBuying,
        breakdownSellingTotal,
    ]);

// ✅ ALL_IN modunda inputlar birbirini tamamlasın
    useEffect(() => {
        if (hydratingFromDb) return;
        if (useLineSelling) return;
        if (!exchangeRates) return;

        const buying = toNum(totalBuying);
        if (!Number.isFinite(buying)) return;

        const safeSet = (setter, next) => {
            const n = next == null ? "" : String(next);
            setter((prev) => (String(prev) === n ? prev : n));
        };

        const source = activeSellingField || sellingDriver;

        if (source === "PERCENT") {
            if (marginPercentInput === "") return;
            const pct = Number(marginPercentInput);
            if (Number.isNaN(pct)) return;

            const unit = (buying * pct) / 100;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "UNIT") {
            if (marginUnitInput === "") return;
            const unit = Number(marginUnitInput);
            if (Number.isNaN(unit)) return;

            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginPercentInput, pct.toFixed(2));
            safeSet(setSellingRateInput, (buying + unit).toFixed(2));
            return;
        }

        if (source === "SELLING") {
            if (sellingRateInput === "") return;
            const manual = Number(sellingRateInput);
            if (Number.isNaN(manual)) return;

            const unit = manual - buying;
            const pct = buying > 0 ? (unit / buying) * 100 : 0;
            safeSet(setMarginUnitInput, unit.toFixed(2));
            safeSet(setMarginPercentInput, pct.toFixed(2));
        }
    }, [
        hydratingFromDb,
        useLineSelling,
        exchangeRates,
        totalBuying,
        activeSellingField,
        sellingDriver,
        marginPercentInput,
        marginUnitInput,
        sellingRateInput,
    ]);

// ✅ Line selling varsa marginleri otomatik doldur (read-only gibi)
    useEffect(() => {
        if (hydratingFromDb) return;
        if (!useLineSelling) return;
        if (activeSellingField) return;
        if (!exchangeRates) return;

        const buying = toNum(totalBuying);
        const selling = toNum(breakdownSellingTotal);

        const unit = selling - buying;
        const pct = buying > 0 ? (unit / buying) * 100 : 0;

        const safeSet = (setter, next) => {
            const v = next == null ? "" : String(next);
            setter((prev) => (String(prev) === v ? prev : v));
        };

        safeSet(setSellingRateInput, selling.toFixed(2));
        safeSet(setMarginUnitInput, unit.toFixed(2));
        safeSet(setMarginPercentInput, pct.toFixed(2));
        setSellingDriver("SELLING");
    }, [
        hydratingFromDb,
        useLineSelling,
        activeSellingField,
        exchangeRates,
        breakdownSellingTotal,
        totalBuying,
    ]);


// ✅ kartta gösterilen sallingRate state'ini engine ile senkron tut
    useEffect(() => {
        if (!exchangeRates) return;
        setSallingRate(toNum(sellingCalc.finalSelling).toFixed(2));
    }, [exchangeRates, sellingCalc.finalSelling]);


    const carrierSellingTotal = exchangeRates
        ? carriers.reduce(
            (s, c) => s + convertToBase(c.sellingCarriers, c.sellingCarriersRate || c.currency || baseCurrency),
            0
        )
        : 0;

    const extraSellingTotal = exchangeRates
        ? extraCosts.reduce(
            (s, e) => s + convertToBase(e.extraSelling, e.extraSellingRate || baseCurrency),
            0
        )
        : 0;

    const lineSellingTotal = carrierSellingTotal + extraSellingTotal;



    // Teklif numarasını kayıt sırasında backend verir (yeni teklifte alan "Auto-generated" gösterir)

    const handleSwitchChangeQuotingType = (type) => {
        setQuoteType((prevType) => (prevType === type ? "" : type));
    };

    const handleSwitchChangeTransportType = (type) => {
        setModeType((prev) => {
            if (prev[0] === type) return [];
            return [type];
        });
    };


    const handleSwitchChange = () => {
        setIsADR(!isADR);
        if (isADR) setImco(null);
    };

    const handleIMCOChange = (event, newValue) => {
        setImco(newValue ? newValue.label : null);
    };

    const addCarrier = () => {
        setCarriers([...carriers, { id: carriers.length + 1, name: "", cost: "", currency: "USD" }]);
    };

    const removeCarrier = (index) => {
        const updatedCarriers = carriers.filter((_, i) => i !== index);
        setCarriers(updatedCarriers);
    };

    const handleCarrierChange = (index, field, value) => {
        const updatedCarriers = carriers.map((carrier, i) => (i === index ? { ...carrier, [field]: value } : carrier));
        setCarriers(updatedCarriers);
    };

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getServiceProviders();

                const options = (response.data ?? []).map((item) => ({
                    id: item.id,
                    name: item?.attributes?.name || "Unnamed Service Provider",
                    type: "serviceProvider",
                }));

                setCarrierOptions(options);
            } catch (error) {
                console.error("Service Provider verileri alınırken hata oluştu:", error);
                setCarrierOptions([]);
            }
        };

        fetchServiceProviders();
    }, []);

    const inputStyle = {
        "& .MuiOutlinedInput-input": { padding: "10px 14px" },
        "& .MuiInputBase-root": { height: 40 },
    };


    const addExtra = () => {
        setExtraCosts([...extraCosts, {
            type: "",
            amount: "",
            currency: "USD",
            extraSelling: "",
            extraSellingRate: "USD",
        }]);
    };

    const removeExtra = (index) => {
        setExtraCosts(extraCosts.filter((_, i) => i !== index));
    };

    const handleExtraChange = (index, field, value) => {
        setExtraCosts(prev =>
            prev.map((e, i) => i === index ? { ...e, [field]: value } : e)
        );
    };


    useEffect(() => {
        if (hydratingFromDb) return;
        if (!exchangeRates) return;
        if (airPricingMode !== "ALL_IN") return;

        // kullanıcı şu an bir alanla uğraşıyorsa elleme
        if (activeSellingField) return;

        const base = useLineSelling ? toNum(lineSellingTotal) : toNum(totalBuying);

        // ilk kez ALL_IN'e geçince sellingRateInput boşsa otomatik doldur
        if ((sellingRateInput ?? "") === "") {
            setSellingDriver("SELLING");
            setSellingRateInput(base.toFixed(2));
        }
    }, [
        hydratingFromDb,
        exchangeRates,
        airPricingMode,
        activeSellingField,
        lineSellingTotal,
        sellingRateInput,
    ]);

    useEffect(() => {
        if (!exchangeRates) return;
        if (airPricingMode !== "BREAKDOWN") return;

        const carrierSelling = carriers.reduce(
            (s, c) =>
                s +
                convertToBase(
                    c.sellingCarriers,
                    c.sellingCarriersRate || c.currency
                ),
            0
        );

        const extraSelling = extraCosts.reduce(
            (s, e) =>
                s + convertToBase(e.extraSelling, e.extraSellingRate),
            0
        );

        setSallingRate((carrierSelling + extraSelling).toFixed(2));
    }, [carriers, extraCosts, airPricingMode, exchangeRates, currency]);

    useEffect(() => {
        if (hydratingFromDb) return;
        if (!exchangeRates) return;
        if (airPricingMode !== "ALL_IN") return;

        // kullanıcı yazarken elleme
        if (activeSellingField) return;

        // engine sonucu (final)
        const next = toNum(sellingCalc.finalSelling).toFixed(2);

        // sellingRateInput güncel değilse set et
        setSellingRateInput((prev) => (String(prev) === String(next) ? prev : next));
    }, [
        hydratingFromDb,
        exchangeRates,
        airPricingMode,
        activeSellingField,
        sellingCalc.finalSelling,
    ]);


    useEffect(() => {
        if (isEditing && selectedCustomer) {
            setInputValue(selectedCustomer.name);
            setOpen(false);
        }
    }, [isEditing, selectedCustomer]);

    return (
        <Grid container spacing={0} justifyContent="center" mb={1}>
            <Grid item xs={12} lg={10}>
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox mb={1} textAlign="center">
                                <div
                                    ref={successMessageRef}
                                    style={{
                                        backgroundColor: successMessage ? "#7edd82" : errorMessage ? "#e57373" : "transparent",
                                        color: successMessage || errorMessage ? "#FFFFFF" : "transparent",
                                        padding: "10px",
                                        textAlign: "center",
                                        marginBottom: "10px",
                                        borderRadius: "5px",
                                        visibility: successMessage || errorMessage ? "visible" : "hidden",
                                    }}
                                >
                                    {successMessage || errorMessage}
                                </div>
                                {isEditing && editDataLoaded && savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling) && (
                                    <div
                                        style={{
                                            backgroundColor: "#fff3cd",
                                            color: "#664d03",
                                            padding: "10px",
                                            textAlign: "center",
                                            marginBottom: "10px",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        {savedPricingNotice(savedRecordRef.current, sellingCalc.finalSelling)}
                                    </div>
                                )}

                                <MDBox mb={1}>
                                    <MDTypography variant="h3" fontWeight="bold">
                                        {isEditing ? " Edit Project Cargo Quote Details" : " Add Project Cargo Quote Details"}
                                    </MDTypography>
                                </MDBox>

                                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                    This information will give you more information about the Quote for Project Cargo.
                                </MDTypography>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>

                <MDBox
                    mt={3}
                    sx={{
                        p: 3,
                        borderRadius: "10px",
                        bgcolor: "background.paper",
                        boxShadow: "none",
                    }}
                >
                    <MDBox mb={3}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDBox>
                                        <Grid container spacing={3} alignItems="center">
                                            <Grid item xs={6}>
                                                <MDTypography variant="h6" component="div">
                                                    Quote - Project Cargo {quoteNo}
                                                </MDTypography>
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <Box mt={3} display="flex" justifyContent="flex-start" alignItems="center" gap={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Import"}
                                                    onChange={() => handleSwitchChangeQuotingType("Import")}
                                                    name="importSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": { backgroundColor: quoteType === "Import" ? "orange" : "white" },
                                                        "& .MuiSwitch-track": { backgroundColor: quoteType === "Import" ? "orange" : "white" },
                                                    }}
                                                />
                                            }
                                            label="Import"
                                            sx={{ color: "gray" }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Export"}
                                                    onChange={() => handleSwitchChangeQuotingType("Export")}
                                                    name="exportSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": { backgroundColor: quoteType === "Export" ? "orange" : "white" },
                                                        "& .MuiSwitch-track": { backgroundColor: quoteType === "Export" ? "orange" : "white" },
                                                    }}
                                                />
                                            }
                                            label="Export"
                                            sx={{ color: "gray" }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Domestic"}
                                                    onChange={() => handleSwitchChangeQuotingType("Domestic")}
                                                    name="domesticSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": { backgroundColor: quoteType === "Domestic" ? "orange" : "white" },
                                                        "& .MuiSwitch-track": { backgroundColor: quoteType === "Domestic" ? "orange" : "white" },
                                                    }}
                                                />
                                            }
                                            label="Domestic"
                                            sx={{ color: "gray" }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={quoteType === "Transit"}
                                                    onChange={() => handleSwitchChangeQuotingType("Transit")}
                                                    name="transitSwitch"
                                                    sx={{
                                                        "& .MuiSwitch-thumb": { backgroundColor: quoteType === "Transit" ? "orange" : "white" },
                                                        "& .MuiSwitch-track": { backgroundColor: quoteType === "Transit" ? "orange" : "white" },
                                                    }}
                                                />
                                            }
                                            label="Transit"
                                            sx={{ color: "gray", ml: 2, mr: 18 }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={modeType.includes("BreakBulk")}
                                                    onChange={() => handleSwitchChangeTransportType("BreakBulk")}
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: modeType.includes("BreakBulk") ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: modeType.includes("BreakBulk") ? "#FFECB3" : "#E0E0E0",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="BreakBulk"
                                            sx={{ color: "gray", mr: 2 }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={modeType.includes("OOG")}
                                                    onChange={() => handleSwitchChangeTransportType("OOG")}
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: modeType.includes("OOG") ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: modeType.includes("OOG") ? "#FFECB3" : "#E0E0E0",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="OOG & Heavy Transportation"
                                            sx={{ color: "gray", ml: 2, mr: 2 }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={modeType.includes("Multimodal")}
                                                    onChange={() => handleSwitchChangeTransportType("Multimodal")}
                                                    sx={{
                                                        "& .MuiSwitch-thumb": {
                                                            backgroundColor: modeType.includes("Multimodal") ? "orange" : "white",
                                                        },
                                                        "& .MuiSwitch-track": {
                                                            backgroundColor: modeType.includes("Multimodal") ? "#FFECB3" : "#E0E0E0",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Multimodal"
                                            sx={{ color: "gray", ml: 2 }}
                                        />

                                    </Box>

                                    <MDBox mt={3}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={1}>
                                                <TextField
                                                    type="text"
                                                    label="Quote No"
                                                    value={quoteNo}
                                                    placeholder="Auto-generated"
                                                    disabled
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || Number(value) >= 0) setQuoteNo(value);
                                                    }}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="text"
                                                    label="Transport Type"
                                                    value={selectedTransportType}
                                                    disabled
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Quote Date"
                                                        value={quoteDate}
                                                        onChange={(newValue) => setQuoteDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: inputStyle,
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    value={selectedCustomer}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("customer");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setSelectedCustomer(newValue);
                                                        setInputValue(newValue?.name || "");
                                                        setOpen(false);
                                                    }}
                                                    inputValue={inputValue}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputValue(newInputValue);
                                                        setOpen(newInputValue.length > 0);
                                                    }}
                                                    options={[
                                                        NEW_PARTY_OPTION,
                                                        ...partyOptions,
                                                        // listede olmayan (silinmiş / adı değişmiş) kayıtlı müşteri de seçili görünsün
                                                        ...(selectedCustomer?.name && !partyOptions.some((o) => o.name === selectedCustomer.name) ? [selectedCustomer] : []),
                                                    ]}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    filterOptions={(options, state) =>
                                                        options.filter((option) =>
                                                            (option.name || "").toLowerCase().includes(state.inputValue.toLowerCase())
                                                        )
                                                    }
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={`${option.type}-${option.id}`}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                          {option.type === "customer" ? "(Customer)" : "(Global Agent)"}
                                                                        </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    open={open}
                                                    onClose={() => setOpen(false)}
                                                    onFocus={() => {
                                                        if (!isEditing) setOpen(true);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Search Customer / Global Agent"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{
                                                                "& .MuiInputBase-root": { height: 50 },
                                                            }}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                            }}
                                                        />
                                                    )}
                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                                                    value={findOptionByName(shipper)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("shipper");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setShipper(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                          {option.type === "customer"
                                                                              ? "(Customer)"
                                                                              : option.type === "agent"
                                                                                  ? "(Global Agent)"
                                                                                  : "(Company)"}
                                                                        </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Shipper"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}                                                    value={findOptionByName(consignee)}
                                                    onChange={(event, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setCustomerModalTarget("consignee");
                                                            setCustomerModalOpen(true);
                                                            return;
                                                        }

                                                        setConsignee(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                          {option.type === "customer"
                                                                              ? "(Customer)"
                                                                              : option.type === "agent"
                                                                                  ? "(Global Agent)"
                                                                                  : "(Company)"}
                                                                        </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Consignee"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Cargo Details</MDTypography>
                                        </MDBox>

                                        <Grid container spacing={3} mt={1}>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Commodity"
                                                    value={commodity}
                                                    onChange={(e) => setCommodity(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Gross Weight (kg)"
                                                    value={grossWeight}
                                                    onChange={(e) => setGrossWeight(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2}>
                                                <TextField
                                                    type="number"
                                                    label="Chargeable Weight (kg)"
                                                    value={chargeableWeight}
                                                    onChange={(e) => setChargeableWeight(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>
                                                <Grid item xs={12} sm={2}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={isADR}
                                                                onChange={handleSwitchChange}
                                                                sx={{
                                                                    "& .MuiSwitch-thumb": { backgroundColor: isADR ? "orange" : "white" },
                                                                    "& .MuiSwitch-track": { backgroundColor: isADR ? "orange" : "white" },
                                                                }}
                                                            />
                                                        }
                                                        label="ADR/DG"
                                                        sx={{ color: "gray" }}
                                                    />
                                                </Grid>

                                                {isADR && (
                                                    <Grid item xs={3}>
                                                        <Autocomplete
                                                            options={imcoOptions}
                                                            getOptionLabel={(option) => option.label}
                                                            value={imcoOptions.find((o) => o.label.trim() === imco?.trim()) || null}
                                                            onChange={handleIMCOChange}
                                                            isOptionEqualToValue={(o, v) => o.label === v.label}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="IMCO Class"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={inputStyle}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                )}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <MDBox mt={3}>
                                            <MDTypography variant="h6">Service Details</MDTypography>
                                        </MDBox>

                                        <Grid container spacing={3} mt={1}>
                                            <Grid item xs={12} sm={3}>
                                                <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                                    <DatePicker
                                                        label="Estimated Close Date"
                                                        value={estimatedCloseDate}
                                                        onChange={(newValue) => setEstimatedCloseDate(newValue)}
                                                        format="dd/MM/yyyy"
                                                        slotProps={{
                                                            textField: {
                                                                variant: "outlined",
                                                                fullWidth: true,
                                                                InputLabelProps: { shrink: true },
                                                                sx: inputStyle,
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Transit Time (Days)"
                                                    value={transitTime}
                                                    onChange={(e) => setTransitTime(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Origin Free Time (Hours)"
                                                    value={originFreeTime}
                                                    onChange={(e) => setOriginFreeTime(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    type="text"
                                                    label="Destination Free Time (Hours)"
                                                    value={destinationFreeTime}
                                                    onChange={(e) => setDestinationFreeTime(e.target.value)}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    fullWidth
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(event, newValues) => setSalesRep(newValues)}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={inputStyle}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={incotermsOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedIncoterm ? { label: selectedIncoterm } : null}
                                                    onChange={(event, newValue) => setSelectedIncoterm(newValue ? newValue.label : "")}
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Incoterm"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={inputStyle}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Autocomplete
                                                    options={serviceOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={selectedService ? { label: selectedService } : null}
                                                    onChange={(event, newValue) => setSelectedService(newValue ? newValue.label : "")}
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Service Level"
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            sx={inputStyle}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} sm={3}>
                                            {renderCountryAutocomplete("Pickup Country", countryOptions, pickupCountry, setPickupCountry)}
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            <Autocomplete
                                                value={pickupCity}
                                                onChange={(e, v) => setPickupCity(v)}
                                                options={pickupCityOptions}
                                                getOptionLabel={(o) => o?.label || ""}
                                                isOptionEqualToValue={(o, v) => (o?.label || "") === (v?.label || "")}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Pickup City" variant="outlined" InputLabelProps={{ shrink: true }} fullWidth />
                                                )}
                                                disabled={!pickupCountry}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            {renderCountryAutocomplete("Delivery Country", countryOptions, deliveryCountry, setDeliveryCountry)}
                                        </Grid>

                                        <Grid item xs={12} sm={3}>
                                            <Autocomplete
                                                value={deliveryCity}
                                                onChange={(e, v) => setDeliveryCity(v)}
                                                options={deliveryCityOptions}
                                                getOptionLabel={(o) => o?.label || ""}
                                                isOptionEqualToValue={(o, v) => (o?.label || "") === (v?.label || "")}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Delivery City" variant="outlined" InputLabelProps={{ shrink: true }} fullWidth />
                                                )}
                                                disabled={!deliveryCountry}
                                            />
                                        </Grid>
                                    </Grid>

                                    {/* ✅ Exit Customs Location: country + text -> exportLocation */}
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Exit Customs Location</MDTypography>
                                    </MDBox>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} sm={6}>
                                            {renderCountryAutocomplete("Exit Customs Country", countryOptions, exitCustomsCountry, (v) => {
                                                setExitCustomsCountry(v);
                                                handleStateChange(setExportLocation, "country", v?.label || "");
                                            })}
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                type="text"
                                                label="Exit Customs Info"
                                                value={exportLocation.additionalInfo || ""}
                                                onChange={(e) => handleStateChange(setExportLocation, "additionalInfo", e.target.value)}
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                sx={inputStyle}
                                            />
                                        </Grid>
                                    </Grid>

                                    {/* ✅ Arrival Customs Location: country + text -> importLocation */}
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Arrival Customs Location</MDTypography>
                                    </MDBox>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} sm={6}>
                                            {renderCountryAutocomplete("Arrival Customs Country", countryOptions, arrivalCustomsCountry, (v) => {
                                                setArrivalCustomsCountry(v);
                                                handleStateChange(setImportLocation, "country", v?.label || "");
                                            })}
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                type="text"
                                                label="Arrival Customs Info"
                                                value={importLocation.additionalInfo || ""}
                                                onChange={(e) => handleStateChange(setImportLocation, "additionalInfo", e.target.value)}
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                sx={inputStyle}
                                            />
                                        </Grid>
                                    </Grid>

                                    <MDBox mt={3} display="flex" gap={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={airPricingMode === "ALL_IN"}
                                                    onChange={() => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                    }}                                                />
                                            }
                                            label="All-in"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={airPricingMode === "BREAKDOWN"}
                                                    onChange={() => setAirPricingMode("BREAKDOWN")}
                                                />
                                            }
                                            label="Breakdown"
                                        />
                                    </MDBox>



                                    <MDBox mt={3}>
                                        <MDTypography variant="h6" mb={1}>
                                            Carriers & Freight Costs
                                        </MDTypography>

                                        {carriers.map((carrier, index) => (
                                            <Grid
                                                container
                                                spacing={2}
                                                key={index}
                                                alignItems="center"
                                                mb={1}
                                            >
                                                {/* Carrier */}
                                                <Grid item xs={12} md={4}>
                                                    <Autocomplete
                                                        options={[NEW_SERVICE_PROVIDER_OPTION, ...carrierOptions]}
                                                        value={
                                                            carrierOptions.find((x) => x.name === carrier.name) ||
                                                            (carrier.name
                                                                ? {
                                                                    id: `manual-${carrier.name}`,
                                                                    name: carrier.name,
                                                                    type: "manual",
                                                                }
                                                                : null)
                                                        }
                                                        onChange={(_, newValue) => {
                                                            if (newValue?.type === "new") {
                                                                setServiceProviderModalTargetIndex(index);
                                                                setServiceProviderModalOpen(true);
                                                                return;
                                                            }

                                                            handleCarrierChange(index, "name", newValue?.name || "");
                                                        }}
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option?.type === value?.type && option?.id === value?.id
                                                        }
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={`${option.type}-${option.id}`}>
                                                                {option.type === "new" ? (
                                                                    <strong style={{ color: "#1976d2" }}>
                                                                        + New Account
                                                                    </strong>
                                                                ) : (
                                                                    <>
                                                                        {option.name}
                                                                        <span
                                                                            style={{
                                                                                marginLeft: 8,
                                                                                opacity: 0.7,
                                                                                fontSize: 12,
                                                                            }}
                                                                        >
                                                                        {option.type === "serviceProvider"
                                                                            ? "(Service Provider)"
                                                                            : "(Manual)"}
                                                                    </span>
                                                                                                                    </>
                                                                )}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Service Provider"
                                                                fullWidth
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                {/* Cost */}
                                                <Grid item xs={12} md={2}>
                                                    <TextField
                                                        type="number"
                                                        label="Freight Cost"
                                                        value={carrier.cost ?? ""}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "cost", e.target.value)
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={inputStyle}
                                                    />
                                                </Grid>

                                                {/* Cost Currency */}
                                                <Grid item xs={12} md={1.5}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={carrier.currency ?? ""}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "currency", e.target.value)
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={inputStyle}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                {/* Selling Rate */}
                                                <Grid item xs={12} md={2}>
                                                    <TextField
                                                        type="number"
                                                        label="Selling Rate"
                                                        value={carrier.sellingCarriers ?? ""}
                                                        onChange={(e) =>
                                                            handleCarrierChange(index, "sellingCarriers", e.target.value)
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={inputStyle}
                                                    />
                                                </Grid>

                                                {/* Selling Currency */}
                                                <Grid item xs={12} md={1.5}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={carrier.sellingCarriersRate || carrier.currency}
                                                        onChange={(e) =>
                                                            handleCarrierChange(
                                                                index,
                                                                "sellingCarriersRate",
                                                                e.target.value
                                                            )
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        sx={inputStyle}
                                                    >
                                                        <MenuItem value="USD">USD</MenuItem>
                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                {/* Actions */}
                                                <Grid item xs={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    {index === carriers.length - 1 && (
                                                        <AddRowButton onClick={addCarrier} tooltip="Add carrier" />
                                                    )}

                                                    {index > 0 && (
                                                        <RemoveRowButton onClick={() => removeCarrier(index)} tooltip="Remove carrier" />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </MDBox>

                                    <MDTypography variant="h6" mt={3}>Extra Charges</MDTypography>

                                    {extraCosts.map((row, index) => (
                                        <Grid container spacing={2} alignItems="center" key={index} mt={1}>
                                            <Grid item xs={4}>
                                                <Autocomplete
                                                    options={extraChargeOptions}
                                                    groupBy={(option) => option.group}
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        extraChargeOptions.find((o) => o.label === row.type) || null
                                                    }
                                                    onChange={(_, v) =>
                                                        handleExtraChange(index, "type", v?.label || "")
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Charge Type"
                                                            fullWidth
                                                            variant="outlined"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={inputStyle}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={2}>
                                                <TextField
                                                    type="number"
                                                    label="Cost"
                                                    value={row.amount ?? ""}
                                                    onChange={(e) => handleExtraChange(index, "amount", e.target.value)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    select
                                                    value={row.currency}
                                                    onChange={(e) => handleExtraChange(index, "currency", e.target.value)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                >
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="TRY">TRY</MenuItem>
                                                </TextField>
                                            </Grid>

                                            <Grid item xs={2}>
                                                <TextField
                                                    type="number"
                                                    label="Selling Rate"
                                                    value={row.extraSelling ?? ""}
                                                    onChange={(e) => handleExtraChange(index, "extraSelling", e.target.value)}
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    select
                                                    value={row.extraSellingRate}
                                                    onChange={(e) =>
                                                        handleExtraChange(index, "extraSellingRate", e.target.value)
                                                    }
                                                    fullWidth
                                                    sx={{ "& .MuiInputBase-root": { height: 50 } }}
                                                >
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                </TextField>
                                            </Grid>

                                            <Grid item xs={1} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                {index === extraCosts.length - 1 && (
                                                    <AddRowButton onClick={addExtra} tooltip="Add charge" />
                                                )}

                                                {index > 0 && (
                                                    <RemoveRowButton onClick={() => removeExtra(index)} tooltip="Remove charge" />
                                                )}
                                            </Grid>

                                        </Grid>
                                    ))}

                                    <MDBox mt={3}>
                                        <MDTypography variant="h6" mb={1}>
                                            Selling Rate Details
                                        </MDTypography>

                                        <Grid container spacing={2} alignItems="center">
                                            {/* Margin % */}
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    label="Margin %"
                                                    type="number"
                                                    value={marginPercentInput}
                                                    disabled={airPricingMode === "BREAKDOWN" || loadingRates}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("PERCENT");
                                                        setSellingDriver("PERCENT");
                                                        setMarginPercentInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("PERCENT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            {/* Margin per unit */}
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    label={`Margin per ${baseCurrency}`}
                                                    type="number"
                                                    value={marginUnitInput}
                                                    disabled={airPricingMode === "BREAKDOWN" || loadingRates}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("UNIT");
                                                        setSellingDriver("UNIT");
                                                        setMarginUnitInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("UNIT")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            {/* Selling Rate */}
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    type="number"
                                                    label="Selling Rate"
                                                    value={sellingRateInput}
                                                    disabled={airPricingMode === "BREAKDOWN"}
                                                    onChange={(e) => {
                                                        setAirPricingMode("ALL_IN");
                                                        clearLineSelling();
                                                        setActiveSellingField("SELLING");
                                                        setSellingDriver("SELLING");
                                                        setSellingRateInput(e.target.value);
                                                    }}
                                                    onFocus={() => setActiveSellingField("SELLING")}
                                                    onBlur={() => setActiveSellingField(null)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>

                                            {/* Currency */}
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={currency}
                                                    onChange={(e) => setCurrency(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                >
                                                    <MenuItem value="USD">USD</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="TRY">TRY</MenuItem>
                                                    <MenuItem value="GBP">GBP</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox
                                        mt={4}
                                        p={3}
                                        sx={{
                                            borderRadius: 2,
                                            background: "#f9f9f9",
                                            border: "1px solid #e0e0e0",
                                        }}
                                    >
                                        <Grid container spacing={3}>

                                            <Grid item xs={6}>
                                                <MDTypography variant="body2" color="text">
                                                    Total Buying Rate
                                                </MDTypography>
                                                <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#2e7d32" }}>
                                                    {totalBuying.toFixed(2)}{" "}
                                                    <span style={{ fontSize: "0.7em" }}>{baseCurrency}</span>                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    Includes Extra Costs: {totalExtraBuying.toFixed(2)} {baseCurrency}
                                                </MDTypography>

                                            </Grid>

                                            <Grid item xs={12} md={6} textAlign={{ xs: "left", md: "right" }}>
                                                <MDTypography variant="body2" color="text">
                                                    Total Selling Rate</MDTypography>
                                                <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#2e7d32" }}>
                                                    {Number(sallingRate || 0).toFixed(2)}
                                                    <span style={{ fontSize: "0.7em" }}> {baseCurrency}</span>
                                                </MDTypography>
                                                <MDTypography variant="caption" color="text">
                                                    Includes Extra Selling: {totalExtraSelling.toFixed(2)}
                                                    <span style={{ fontSize: "0.7em" }}> {baseCurrency}</span>
                                                </MDTypography>
                                            </Grid>

                                        </Grid>
                                    </MDBox>



                                    <MDBox mt={3}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    type="text"
                                                    label="Description"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={inputStyle}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <MDBox mt={3}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={statusOptions}
                                                    getOptionLabel={(o) => o.label}
                                                    value={statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null}
                                                    onChange={(e, newValue) => setSelectedStatus(newValue?.value || newValue?.label || "")}
                                                    isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                                                            <Dot color={option.color} />
                                                            {option.label}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => {
                                                        const current = statusOptions.find((o) => o.value === selectedStatus || o.label === selectedStatus) || null;

                                                        return (
                                                            <TextField
                                                                {...params}
                                                                label="Select Business Status"
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    ...inputStyle,
                                                                    "& .MuiInputBase-root": { alignItems: "center" },
                                                                }}
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    startAdornment: (
                                                                        <span style={{ display: "flex", alignItems: "center", marginRight: 6 }}>
                                      <Dot color={current?.color} />
                                                                            {params.InputProps.startAdornment}
                                    </span>
                                                                    ),
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>

                    <div>
                        <form onSubmit={submitHandler}>
                            <Button variant="contained" onClick={submitHandler}
                                disabled={loading || !!successMessage} style={{ backgroundColor: "#0B1F3A", color: "#FFFFFF" }}>
                                {isEditing ? "Update Quote" : "Create Quote"}
                            </Button>
                        </form>
                    </div>
                </MDBox>
            </Grid>
            <Dialog
                open={customerModalOpen}
                onClose={() => setCustomerModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Customer
                    <IconButton
                        onClick={() => setCustomerModalOpen(false)}
                        sx={{ position: "absolute", right: 12, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateCustomer
                        isModal
                        onClose={() => setCustomerModalOpen(false)}
                        onCreated={handleCustomerCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={serviceProviderModalOpen}
                onClose={() => {
                    setServiceProviderModalOpen(false);
                    setServiceProviderModalTargetIndex(null);
                }}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Service Provider

                    <IconButton
                        onClick={() => {
                            setServiceProviderModalOpen(false);
                            setServiceProviderModalTargetIndex(null);
                        }}
                        sx={{
                            position: "absolute",
                            right: 12,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateServiceProvider
                        isModal
                        onClose={() => {
                            setServiceProviderModalOpen(false);
                            setServiceProviderModalTargetIndex(null);
                        }}
                        onCreated={handleServiceProviderCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>
        </Grid>

    );
};

export default ProjectCargoForm;
